var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box } from '..';
var sizes = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
};
var paddings = {
    sm: 3,
    md: [3, null, 4],
    lg: [3, null, 4],
    xl: [3, null, 4],
};
var propTypes = {
    maxWidth: PropTypes.number,
    // Set the max width and padding of the container. Do not use with maxWidth prop.
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
};
var Container = styled(Box).attrs(function (props) {
    if (props.size) {
        var px = paddings[props.size];
        var maxWidth = props.size ? "".concat(sizes[props.size], "px") : props.maxWidth;
        return { px: px, maxWidth: maxWidth };
    }
    else {
        return props.maxWidth ? { maxWidth: "".concat(props.maxWidth, "px") } : { maxWidth: props.theme.maxContainerWidth };
    }
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n"], ["\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n"])));
Container.propTypes = propTypes;
Container.displayName = 'Container';
export default Container;
var templateObject_1;
//# sourceMappingURL=Container.js.map